import { takeLatest, call, put, all } from 'redux-saga/effects';

import { ApiResponse, postApi } from 'services/_api';

import { PATH_DETRAN_CRV, CHANNEL } from 'services/_path';

import { ReducerAction } from 'store/modules/types';

import { Types, IPTRESRequest } from './types';

import { consultarPTRESSuccess, consultarPTRESFailure } from './actions';

function* consultarPTRESRequest(request: ReducerAction) {
	const { payload }: { payload: IPTRESRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`resumo-veiculo/${CHANNEL}/pesquisa/simples`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultarPTRESSuccess(response));
	} else if (response.error) {
		yield put(consultarPTRESFailure(response));
	}
}

export default all([takeLatest(Types.PTRES_REQUEST, consultarPTRESRequest)]);
